import { render, staticRenderFns } from "./ReportWater.vue?vue&type=template&id=52d172c6&scoped=true&"
import script from "./ReportWater.vue?vue&type=script&lang=js&"
export * from "./ReportWater.vue?vue&type=script&lang=js&"
import style0 from "./ReportWater.vue?vue&type=style&index=0&id=52d172c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d172c6",
  null
  
)

export default component.exports